/**
 * Hime cuts — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_named_haircuts`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const himeCutsPack: ToilePack = {
    slug: 'hime-cuts',
    category: 'beauty',
    name: 'Hime cuts',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'classic', label: 'Classic hime', subject: 'long straight hair with blunt cheek-length side panels and blunt bangs'},
        {key: 'soft', label: 'Soft hime', subject: 'a softer hime cut with wispy bangs and feathered side panels'},
        {key: 'layered', label: 'Layered hime', subject: 'a hime cut with layers through the back length'},
    ],
    styles: [
        {key: 'salon', label: 'Salon', style: 'photographed in a bright hair salon by soft broad window daylight from camera-left, a light and open balance with few dark tones', palette: 'white walls and pale ash wood, the hair the darkest tone', framing: 'near-frontal head-and-shoulders at eye level, the salon mirror soft behind'},
        {key: 'tokyo', label: 'Tokyo street', style: 'on a quiet Tokyo side street in overcast daylight from above, a soft even balance with open shadows', palette: 'grey concrete with small colour accents soft in the distance', framing: 'eye-level head-and-shoulders, shallow depth of field, the street soft behind'},
        {key: 'night', label: 'Night city', style: 'on a city street at night, coloured shop-sign glow from camera-right on the face and hair, a dark balance with large shadow areas and light only on the turned planes', palette: 'magenta and cyan glow over a near-black street', framing: 'three-quarter view, city bokeh behind'},
    ],
    directions: ['pastel pink', 'with ribbon', 'jet black'],
    directionHint: 'try: pastel pink',
    seo: {
        title: 'Hime Cuts: Classic, Soft, Layered',
        metaDescription: 'Nine pictures of the hime cut, blunt cheek-length side panels with blunt bangs: a classic, a soft and a layered version in three settings.',
        h1: 'Hime cuts: classic, soft, layered',
        tagline: 'Nine pictures, three hime cuts, each in a salon, on a Tokyo street and in a city at night.',
        intro: 'The hime cut is a Japanese style with blunt bangs and side panels that stop at the cheeks. These pictures show a classic hime with blunt cheek-length side panels, a soft hime with wispy bangs and feathered panels, and a layered hime with layers through the back. Each is seen in a salon, on a Tokyo street and at night in a city. You can type a change, such as pastel pink, to ask for the cut with it.',
        useCases: [
            'a reference for blunt geometry',
            'choosing a classic, soft or layered hime',
            'a wall print',
            'a profile picture',
        ],
        faq: [
            {q: 'What is a hime cut?', a: 'Long hair with blunt bangs and side panels that end at the cheeks.'},
            {q: 'What is the difference between the classic and the soft?', a: 'The classic has blunt bangs and blunt side panels. The soft version has wispy bangs and feathered panels.'},
            {q: 'Can I change the colour?', a: 'Yes. Type the change and the picture is made with it. It is a request, so the result may differ from the sample.'},
        ],
    },
}
